<template>
    <transition name="fade">
      <div
          v-if="visible"
          class="fixed top-0 top-[-1rem] inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 dark:text-white"
          @click.self="close"
      >
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-md p-4 md:p-6 mx-4 sm:mx-6">
          <!-- Modal Header -->
          <div class="flex justify-between items-center border-b pb-3">
            <h2 class="text-xl font-semibold text-gray-800 dark:text-gray-200">
              {{ title }}
            </h2>
            <button
              @click="toggleLock"
              class="ml-2 px-2 py-1 rounded text-xs font-medium"
              :class="selectedDriver.locked ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-red-600 text-white hover:bg-red-700'"
              :title="selectedDriver.locked ? 'Odblokuj użytkownika' : 'Zablokuj użytkownika'"
            >
              {{ selectedDriver.locked ? 'Odblokuj' : 'Zablokuj' }}
            </button>
          </div>
  
          <!-- Modal Body -->
          <div class="mt-4">
            <slot></slot>
          </div>
  
          <!-- Modal Footer -->
          <div class="mt-6 flex flex-wrap justify-between gap-2">
            <!-- Przycisk "Szczegóły" -->
            <button
                @click="$emit('goToProfile', selectedDriver)"
                class="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-500 flex items-center justify-center space-x-2"
            >
              <DocumentIcon class="w-4 h-4" />
              <span>Szczegóły</span>
            </button>
  
            <!-- Przycisk "Edytuj" -->
            <button
                v-if="userRole !== 'ROLE_YOUNG_DISPATCHER'"
                @click="$emit('openEditModal', selectedDriver)"
                class="flex-1 px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-400 flex items-center justify-center space-x-2"
            >
              <PencilIcon class="w-4 h-4" />
              <span>Edytuj</span>
            </button>
  
            <!-- Przycisk "Usuń" -->
            <button
                v-if="userRole !== 'ROLE_YOUNG_DISPATCHER'"
                @click="$emit('deleteDriver', selectedDriver.id)"
                class="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-500 flex items-center justify-center space-x-2"
            >
              <TrashIcon class="w-4 h-4" />
              <span>Usuń</span>
            </button>
  
            <!-- Przycisk "Zamknij" -->
            <button
                @click="close"
                class="flex-1 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 flex items-center justify-center space-x-2"
            >
              <span>Zamknij</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  import userService from "@/services/userService";
  import { DocumentIcon, PencilIcon, TrashIcon } from "@heroicons/vue/24/solid";
  
  export default {
    name: "DriverInformationModal",
    components: {
      DocumentIcon,
      PencilIcon,
      TrashIcon,
    },
    props: {
      visible: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: "Modal",
      },
      selectedDriver: {
        type: Object,
        required: true,
      },
      userRole: {
        type: String,
        default: "",
      },
    },
    emits: ["close", "goToProfile", "openEditModal", "deleteDriver"],
    methods: {
      close() {
        this.$emit("close");
      },
      async toggleLock() {
        if (!this.selectedDriver) return;
        try {
          if (this.selectedDriver.locked) {
            await userService.unlockUser(this.selectedDriver);
            this.$emit("updateLocked", false);
          } else {
            await userService.lockUser(this.selectedDriver);
            this.$emit("updateLocked", true);
          }
        } catch (e) {
          alert("Nie udało się zmienić statusu blokady użytkownika.");
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  .fade-enter-to,
  .fade-leave-from {
    opacity: 1;
  }
  </style>